import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=65e59b8d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=65e59b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e59b8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e59b8d')) {
      api.createRecord('65e59b8d', component.options)
    } else {
      api.reload('65e59b8d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=65e59b8d&scoped=true&", function () {
      api.rerender('65e59b8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28LdKzJa255hE/JS/comp/GuestBox.vue"
export default component.exports